<template>
  <div class="outer">
    <div class="adminlogin" v-if="user && isAdmin">
      <div>
        Logged In As <strong>{{ user.identity }}</strong>
      </div>
    </div>
    <!-- <div class="sneakPeek" v-else-if="enableSneakPeek">
      <div>You're looking at a sneak peek of our new portal! <a href="#">See what's new</a></div>
    </div> -->

    <div class="layout-leftnav">
      <template>
        <NavLeft
          v-if="isLoggedIn"
          :loading="menu.loading"
          :back="menu.back"
          :menuTitle="menu.title"
          :menuItems="menu.links"
          :helpItems="helpLinks"
          class="d-none d-lg-flex"
        />
        <div class="right-content">
          <template v-if="isLoggedIn">
            <NavTopMobile
              class="d-lg-none"
              :user="user"
              :client="client"
              :userMenuItems="userMenuItemsMobile"
              :loading="menu.loading"
              :back="menu.back"
              :menuTitle="menu.title"
              :menuItems="menu.links"
              :helpItems="helpLinks"
            />
            <NavTopAuth
              class="d-none d-lg-block"
              :client="client"
              :user="user"
              :userMenuItems="userMenuItemsMobile"
              :userLoginableItems="userLoginableItems"
            />
          </template>
          <NavTopAnon v-else />
          <div class="content">
            <slot></slot>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { init, startChat } from "@/utils/lw-chat";
import { canWrite } from "@/utils/useAuth";
import chatConfig from "@/utils/lw-chat.config";
import { computed } from "@vue/composition-api";
import ContactSupport from "@/components/smart/modals/ContactSupport";
import i18n from "@/i18n";
import NavLeft from "@/components/nav/NavLeft";
import NavLink from "@/classes/NavLink";
import NavTopAnon from "@/components/nav/NavTopAnon";
import NavTopAuth from "@/components/nav/NavTopAuth";
import NavTopMobile from "@/components/nav/NavTopMobile";
import store from "@/store";
import SwitchClient from "@/components/smart/modals/SwitchClient";
import UpdateDefaultClient from "@/components/smart/modals/UpdateDefaultClient";

export default {
  name: "GlobalNav",
  components: {
    NavLeft,
    NavTopAnon,
    NavTopAuth,
    NavTopMobile,
  },
  setup() {
    const createNavLinks = (links) => {
      return links.map((link) => {
        const linkName = i18n.t(`navigation.${link.name}`, link.meta);
        return new NavLink(linkName, link.icon, link.action || link.route);
      });
    };

    const userMenuItems = computed(() => {
      return createNavLinks([
        {
          name: "profile",
          route: "profile",
        },
        {
          name: "2fa",
          route: "2fa",
        },
        {
          name: "feedback",
          route: "feedback",
        },
        {
          name: "signout",
          route: "logout",
        },
      ]);
    });

    const helpLinks = [
      new NavLink("Chat", "chat", () => {
        console.log(chatConfig);
        init(chatConfig).then(() => {
          startChat({
            extraDetails: {
              //TO DO: send real token once back end auth pieces are available
              ChatAuthToken:
                "eyJ0eXAiOiJKV1QiLCJhbGciOi1234567899.eyJ2ZXIiOiIxIiwiaWF0IjoxNjEwNTU1MDAyLCJzdWIiOiJ7XCJleHRyYW5ldFwiOntcImNsaWVudFwiOjM4NTgyLFwidXNlclwiOjYxOTAzfX0iLCJleHAiOjE2MTA1NjIyMDIsImFsdiI6Mn0.DXbYlgZngo2usCax_v5wdEXyLS--HJu-Q9exBXQePPA",
            },
          });
        });
      }),
      new NavLink("Email", "email", () => {
        return store.dispatch("modals/open", { template: ContactSupport });
      }),
      new NavLink("Call", "call", () => {
        return window.open("tel:+1866-639-2377");
      }),
    ];

    const menu = computed(() => {
      return store.getters["nav/getMenu"];
    });

    const isLoggedIn = computed(() => {
      return store.getters["auth/isLoggedIn"];
    });
    const isAdmin = computed(() => {
      return store.getters["auth/isAdmin"];
    });

    const client = computed(() => {
      return store.state.auth.client;
    });

    const user = computed(() => {
      return store.state.auth.user;
    });

    const userLoginableItems = computed(() => {
      return store.getters["auth/getLoginableClients"];
    });

    /*
      ORIGINAL TOP RIGHT MENU LIST
      kb
      ssh
      api
      2fa
      settings
      refer friend
      team
      addresses
      announcements
      switch
      set default
      feedback
      sign out
    */
    const userMenuItemsMobile = computed(() => {
      const menuItems = [];

      menuItems.push({ name: "profile", route: "profile" });
      menuItems.push({ name: "2fa", route: "2fa" });
      menuItems.push({ name: "ssh-keys", route: "ssh-keys" });
      if (canWrite("users")) {
        menuItems.push({ name: "team", route: "team" });
      }
      menuItems.push({ name: "api-tokens", route: "api-tokens" });
      menuItems.push({ name: "refer-a-friend", route: "refer-a-friend" });
      menuItems.push({ name: "addresses", route: "payment-info" });

      let menuLinks = createNavLinks(menuItems);

      if (userLoginableItems.value && userLoginableItems.value.length > 1) {
        const loginableLinks = createNavLinks([
          {
            name: "switch-client",
            action: () => {
              store.dispatch("modals/open", {
                template: SwitchClient,
              });
            },
          },
          {
            name: "set-default-client",
            action: () => {
              store.dispatch("modals/open", {
                template: UpdateDefaultClient,
              });
            },
          },
        ]);

        menuLinks = menuLinks.concat(loginableLinks);
      }

      const endLinks = createNavLinks([
        {
          name: "feedback",
          route: "feedback",
        },
        {
          name: "announcements",
          route: "announcements",
        },
        {
          name: "knowledge-base",
          action: () => {
            window.open("https://help.nexcess.net/");
          },
        },
        {
          name: "signout",
          route: "logout",
        },
      ]);

      menuLinks = menuLinks.concat(endLinks);

      return menuLinks;
    });

    // const enableSneakPeek = false;

    return {
      userMenuItems,
      userMenuItemsMobile,
      user,
      client,
      isLoggedIn,
      menu,
      isAdmin,
      userLoginableItems,
      helpLinks,
      // enableSneakPeek,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables";

.outer {
  display: flex;
  flex-direction: column;
  height: 100%;
  .adminlogin,
  .sneakPeek {
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.875rem;
  }

  .layout-leftnav {
    flex: 1;
    display: flex;
    flex-direction: row;
    // height: 100%;
    overflow: auto;
    min-height: 0;

    .right-content {
      flex: 1;
      display: flex;
      flex-direction: column;
      height: 100%;
      overflow-x: hidden;

      .content {
        // padding: $content-top-padding $grid-gutter-width;
        overflow: auto;
        flex-grow: 1;
      }
    }
    .header {
      height: $header-height;
      flex-grow: 0;
    }

    .loader {
      height: 100%;
      width: 100%;
    }
  }
}
</style>
